import { t } from "@/i18n-js/instance";
import { BuildingBlocks } from "./components/BuildingBlocks";
import { TextContent } from "./components/TextContent";
import { UserInfo } from "./components/UserInfo";
import { useCommunityPreviewData } from "./hooks/useCommunityPreviewData";
import { PreviewCard } from "./layout/PreviewCard";
import { PreviewField } from "./layout/PreviewField";
import { PreviewSection } from "./layout/PreviewSection";
import { PreviewTitle } from "./layout/PreviewTitle";
import { PreviewUserSection } from "./layout/PreviewUserSection";

export interface CommunityPreviewProps {
  communityName: string;
  buildingBlocks?: string[];
}

export const CommunityPreview = ({
  communityName,
  buildingBlocks: customBuildingBlocks,
}: CommunityPreviewProps) => {
  const {
    displayName,
    customerJourneyStage,
    achieveWithCircle,
    buildingBlocks,
    userInitials,
    fullName,
    email,
  } = useCommunityPreviewData(communityName, customBuildingBlocks);

  const localeScope =
    "authentication_app.new_onboarding_flow_april_2025.community_preview";

  return (
    <PreviewCard>
      <PreviewSection>
        <PreviewTitle
          subtitle={t(`${localeScope}.title`)}
          title={displayName}
        />
        {customerJourneyStage && (
          <PreviewField label={t(`${localeScope}.journey_stage`)}>
            <TextContent content={customerJourneyStage} />
          </PreviewField>
        )}
        {achieveWithCircle && (
          <PreviewField label={t(`${localeScope}.achieve_with_circle`)}>
            <TextContent content={achieveWithCircle} />
          </PreviewField>
        )}
        <PreviewField label={t(`${localeScope}.blocks_title`)}>
          <BuildingBlocks blocks={buildingBlocks} />
        </PreviewField>
      </PreviewSection>
      <PreviewUserSection>
        <UserInfo fullName={fullName} email={email} initials={userInitials} />
      </PreviewUserSection>
    </PreviewCard>
  );
};
